// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__38Uic","approved":"Status_approved__3blzv","rejected":"Status_rejected__NkP6D","expired":"Status_expired__abxDR","label":"Status_label___Uw6I"};